import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useSecureAuth } from '../../../hooks/useSecureApi';

/**
 * ProtectedRoute component to check for user authentication.
 * Uses the secure global authentication state.
 * If not authenticated, redirects the user to the login page.
 */
const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, loading } = useSecureAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', background: '#000', color: '#fff' }}>
        Verificando sesión...
      </div>
    );
  }

  if (!isAuthenticated) {
    // Redirect them to the /login page, but save the current location they were trying to go to
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return children;
};

export default ProtectedRoute;
